import {Badge} from '@/components/ui/badge/Badge'
import {User01Icon, Users01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n'

/** A conversation is either about a patient or internal to the staff — never both, never neither */
export type ConversationKind = 'patient' | 'internal'

/**
 * The single place that names the two kinds of conversation, so the notification list and the
 * conversations panel always label them identically.
 *
 * Colour and icon carry the distinction as much as the words do: operators asked to tell the
 * two apart at a glance, without deducing it from the title, the participants or the page
 * underneath.
 */
export const ConversationKindBadge = ({kind}: {kind: ConversationKind}) => {
    const {t} = useTranslation()
    const isPatientConversation = kind === 'patient'

    return (
        <Badge variant={isPatientConversation ? 'primary' : 'neutral'} size="sm" shape="rectangle">
            {isPatientConversation ? <User01Icon /> : <Users01Icon />}
            {t(isPatientConversation ? 'conversations:kind_patient' : 'conversations:kind_internal')}
        </Badge>
    )
}
